import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintReport } from '.';

/**
 * @component {kat-blueprint-report-identify} KatBlueprintReportIdentify Component used to place and filter components within the identify section.
 * @slot default Blueprint content for identify section.
 */
@register(KatBlueprintReport.slotMapping.identify.name)
export class KatBlueprintReportIdentify extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintReport.slotMapping.identify.name,
      KatBlueprintReport.slotMapping.identify.allowed
    );
  }
}
